import React from "react";
import camelcaseKeys from "camelcase-keys";
import { apiResourceUrl } from "@ploy-lib/core";
export class FulfillmentAPI extends React.Component {
    constructor() {
        super(...arguments);
        this.callAPI = async (method, action, params) => {
            const { token } = this.props;
            const noCacheToken = new Date().getTime();
            const response = await fetch(apiResourceUrl(`fulfillment/${action}?${getQueryParams(params)}&t=${noCacheToken}`), {
                method,
                headers: token ? new Headers({ Authorization: token }) : undefined,
                credentials: "include" // Include session cookie
            });
            if (!response.ok) {
                let errorMessage = "Error getting fulfillment.";
                try {
                    const errorData = await response.json();
                    if (errorData?.title)
                        errorMessage = errorData.title;
                    else if (errorData?.detail)
                        errorMessage = errorData.detail;
                }
                catch { }
                throw new Error(errorMessage);
            }
            const data = await response.json();
            return camelcaseKeys(data);
        };
        this.handleGetFulfillment = async (searchParams) => {
            return this.callAPI("GET", "fulfillment", { ...searchParams });
        };
    }
    render() {
        const { children } = this.props;
        return children({
            getFulfillment: this.handleGetFulfillment
        });
    }
}
export const getQueryParams = (params) => {
    return Object.entries(params)
        .map(([k, v]) => encodeURIComponent(k) +
        "=" +
        encodeURIComponent(v instanceof Date ? v.toISOString() : v))
        .join("&");
};
export default FulfillmentAPI;
//# sourceMappingURL=FulfillmentAPI.js.map